import React from 'react'
import { Layout } from 'antd'
import { connect } from 'react-redux'
import classNames from 'classnames'
import Menu from 'components/cleanui/layout/Menu'
import Sidebar from 'components/cleanui/layout/Sidebar'

import styles from './style.module.scss'

const mapStateToProps = ({ settings }) => ({
  isContentMaxWidth: settings.isContentMaxWidth,
  isAppMaxWidth: settings.isAppMaxWidth,
  isGrayBackground: settings.isGrayBackground,
  isSquaredBorders: settings.isSquaredBorders,
  isCardShadow: settings.isCardShadow,
  isBorderless: settings.isBorderless,
  isTopbarFixed: settings.isTopbarFixed,
  isGrayTopbar: settings.isGrayTopbar,
})

const MainLayout = ({
  children,
  isContentMaxWidth,
  isAppMaxWidth,
  isGrayBackground,
  isSquaredBorders,
  isCardShadow,
  isBorderless,
}) => {
  return (
    <div className={classNames('officemail', { cui__layout__grayBackground: isGrayBackground })}>
      <Layout
        className={classNames({
          cui__layout__contentMaxWidth: isContentMaxWidth,
          cui__layout__appMaxWidth: isAppMaxWidth,
          cui__layout__grayBackground: isGrayBackground,
          cui__layout__squaredBorders: isSquaredBorders,
          cui__layout__cardsShadow: isCardShadow,
          cui__layout__borderless: isBorderless,
        })}
      >
        <React.Suspense fallback={<div>Loading...</div>} />
        <Layout.Content style={{ height: '100%', position: 'relative' }}>
          <Layout>
            <Sidebar />
            <Menu menuType="admin" />
            <Layout>
              <Layout.Content style={{ height: '100%', position: 'relative' }}>
                <div className={classNames(styles.content)}>{children}</div>
              </Layout.Content>
            </Layout>
          </Layout>
        </Layout.Content>
      </Layout>
    </div>
  )
}

export default connect(mapStateToProps)(MainLayout)
